// Unified Analytics Manager
import { ANALYTICS_CONFIG, CookieConsent } from '@/config/analytics';
import { initGA4, trackPageView as ga4PageView, trackEvent as ga4Event, trackConversion as ga4Conversion } from './google-analytics';
import { initFacebookPixel, trackFBPageView, trackFBLead, trackFBCompleteRegistration } from './facebook-pixel';
import { initTikTokPixel, trackTikTokPageView, trackTikTokSubmitForm, trackTikTokCompleteRegistration } from './tiktok-pixel';

// Initialize all analytics based on consent
export function initializeAnalytics(consent: CookieConsent): void {
  if (consent.analytics && ANALYTICS_CONFIG.GA4_ENABLED) {
    initGA4(import.meta.env.VITE_GA4_MEASUREMENT_ID);
  }
  
  if (consent.marketing) {
    if (ANALYTICS_CONFIG.FB_PIXEL_ENABLED) {
      initFacebookPixel(import.meta.env.VITE_FB_PIXEL_ID);
    }
    if (ANALYTICS_CONFIG.TIKTOK_PIXEL_ENABLED) {
      initTikTokPixel(import.meta.env.VITE_TIKTOK_PIXEL_ID);
    }
  }
}

// Track page views across all enabled platforms
export function trackPageView(path: string, title?: string): void {
  ga4PageView(path, title);
  trackFBPageView();
  trackTikTokPageView();
}

// Track custom events
export function trackEvent(
  action: string,
  category: string,
  label?: string,
  value?: number
): void {
  ga4Event(action, category, label, value);
}

// Track lead generation
export function trackLeadGeneration(source: string): void {
  ga4Conversion('lead');
  trackFBLead({ value: 0, currency: 'AUD' });
  trackTikTokSubmitForm({ description: source } as any);
}

// Track signup completion
export function trackSignupComplete(): void {
  ga4Conversion('signup');
  trackFBCompleteRegistration({ value: 0, currency: 'AUD' });
  trackTikTokCompleteRegistration({ value: 0, currency: 'AUD' });
}

// Re-export individual modules for direct access
export * from './google-analytics';
export * from './facebook-pixel';
export * from './tiktok-pixel';
